<!-- 
Takes an array of values and displays their corresponding description from the specified lookup.
-->
<template>
  <div>
    <div v-for="item in items" :key="item">{{ item }}</div>
  </div>
</template>

<script>
import _ from "underscore";

export default {
  props: {
    values: {
      default: null,
      type: Array
    },
    lookups: {
      default: null,
      type: Array
    }
  },
  computed: {
    items() {
      if (this.values && this.values.length && this.lookups && this.lookups.length) {
        const descriptions = _(this.lookups).filter(desc => this.values.includes(desc.value));
        return _(descriptions).pluck("text");
      } else {
        return [];
      }
    }
  }
};
</script>
